import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
import { JsonLd, useSEO } from '../utils/seo';
export function Home() {
  useSEO({
    title: 'Gravel Delivery Seattle, WA | Same-Day Bulk Materials | 206Gravel',
    description: 'Order gravel, crushed rock, topsoil, bark, and drain rock online with dependable same-day and next-day delivery across Seattle, King County, and Pierce County.',
    path: '/'
  });
  return <main data-id="element-2741" data-mp="2dirup0mcp005">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: '206Gravel',
      url: 'https://206gravel.com',
      telephone: '+1-206-619-3742',
      email: 'info@206gravel.com',
      priceRange: '$',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Bonney Lake',
        addressRegion: 'WA',
        addressCountry: 'US'
      },
      areaServed: ['Seattle', 'Tacoma', 'Bellevue', 'King County', 'Pierce County'],
      description: 'Locally owned bulk gravel, rock, soil, bark, and aggregate delivery across King and Pierce counties.'
    }} data-id="element-2742" data-mp="2dii4bbxe8qtx" />
      <div className="dark" data-id="element-2743" data-mp="2mwqrd9v9f64a">
        <Hero data-id="element-2744" data-mp="2hxxdhgc29d3l" />
      </div>
      {/* The materials catalog sits directly under the hero. It used to run
          fourth, behind WhyUs and ByTheNumbers, which meant a customer who
          didn't already know their material had to scroll past two trust
          sections before seeing a single product photo. Browsing is the second
          thing the page offers now; the trust sections follow it. */}
      <Services data-id="element-2745" data-mp="1z763qdo5vkoo" />
      <WhyUs data-id="element-2746" data-mp="1z7pbj1k3ksoz" />
      <ByTheNumbers data-id="element-2747" data-mp="1z6eb9bpv232m" />
      <FAQ data-id="element-2748" data-mp="1z6mlevulmua4" />
      <Reviews data-id="element-2749" data-mp="1z9ii6gupncwz" />
      <CtaBanner data-id="element-2750" data-mp="1u8coogt87lme" />
    </main>;
}